import { Card, Button, Icon } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledNotificationCardGroup = styled(Card.Group)`
  margin-bottom: 2rem !important;
`;

export const StyledNotificationCard = styled(Card) <{ $active?: boolean }>`
  border: 1.5px solid ${({ $active }) => ($active ? '#f5c6c6' : '#e0e0e0')} !important;
  box-shadow: none !important;
  border-radius: 10px !important;
  transition: border-color 0.2s !important;
  min-width: 280px !important;
  min-height: 220px !important;
`;

export const StyledCardContent = styled(Card.Content)`
  padding: 18px !important;
`;

export const StyledIconBox = styled.div<{ $active?: boolean }>`
  width: 48px;
  min-width: 48px;
  height: 48px;
  border-radius: 10px;
  background-color: ${({ $active }) => ($active ? '#C62828' : '#f3f4f6')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  transition: background-color 0.2s;
  .calendar.icon::before {    
    color: ${({ $active }) => ($active ? '#ffffff' : '#9ca3af')} !important;
  }
`;

export const StyledNotificationIcon = styled(Icon) <{ $active?: boolean }>`
  color: ${({ $active }) => ($active ? '#ffffff' : '#9ca3af')} !important;
  margin: 0 !important;
  font-size: 1.2em !important;
`;

export const StyledCardHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;

  .field {
    margin: 0px !important;
    margin-bottom: 5px !important;
  }
`;

export const StyledRequiredMark = styled.span`
  color: #C62828;
`;

export const StyledNotificationDescription = styled.p`
  font-size: 0.85em;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
`;

export const StyledEmailSection = styled.div`
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledEmailRow = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 6px 12px;

  > i.icon {
    color: #9ca3af !important;
    margin: 0 !important;
    flex-shrink: 0;
  }

  .field {
    flex: 1;
    margin: 0 !important;
  }

  .ui.input {
    width: 100%;
  }

  input {
    border: none !important;
    background: transparent !important;
    padding: 4px 0 !important;
    box-shadow: none !important;
    outline: none !important;
  }
`;

export const StyledAddButton = styled(Button)`
  background-color: #C62828 !important;
  color: #ffffff !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
  min-width: 36px !important;
  flex-shrink: 0 !important;

  i.icon {
    margin: 0 !important;
  }
`;

export const StyledEmailTrashButton = styled(Button)`
  background: transparent !important;
  box-shadow: none !important;
  padding: 4px 6px !important;
  color: #9ca3af !important;
  border: none !important;
  font-size: 1.2em !important;
  flex-shrink: 0 !important;
  
  &:hover {  
    background: none !important;
  }

  i.icon {
    margin: 0 !important;
  }
`;
